import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SettingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SettingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M14.1661 22.0005H9.83731C9.46315 22.0005 9.1458 21.7253 9.09241 21.3545L8.78975 19.2349C8.27111 19.0062 7.78431 18.7276 7.33522 18.4014L5.35324 19.1967C5.00748 19.3373 4.60834 19.1992 4.42175 18.875L2.25759 15.126C2.07052 14.8018 2.14985 14.3894 2.44467 14.1583L4.12889 12.836C4.09559 12.5436 4.07894 12.2679 4.07894 12.0005C4.07894 11.7331 4.09559 11.4574 4.12889 11.165L2.44467 9.84269C2.14984 9.61153 2.07051 9.19917 2.25759 8.87496L4.42175 5.126C4.60786 4.8013 5.00357 4.66319 5.35324 4.80424L7.33522 5.59958C7.78284 5.27489 8.26818 4.99623 8.78534 4.76801L9.08849 2.64645C9.14187 2.27572 9.45923 2.00049 9.83339 2.00049H14.1617C14.5359 2.00049 14.8532 2.27572 14.9066 2.64645L15.2093 4.76605C15.7279 4.99476 16.2147 5.27342 16.6638 5.59958L18.6458 4.80424C18.993 4.66516 19.3907 4.8018 19.5773 5.126L21.7419 8.87496C21.929 9.19917 21.8497 9.61154 21.5548 9.84269L19.8706 11.165C19.9039 11.4554 19.9201 11.7316 19.9201 12.0005C19.9201 12.2694 19.9039 12.5456 19.8706 12.836L21.5548 14.1583C21.8497 14.3894 21.929 14.8018 21.7419 15.126L19.5773 18.875C19.3902 19.1987 18.993 19.3358 18.6458 19.1967L16.6638 18.4014C16.2162 18.7266 15.7309 19.0048 15.2137 19.2335L14.911 21.3545C14.8577 21.7253 14.5403 22.0005 14.1661 22.0005ZM10.4896 20.496H13.5138L13.7851 18.5943C13.8243 18.3225 14.0075 18.0938 14.2641 17.9969C14.9311 17.7451 15.5379 17.3964 16.0673 16.9615C16.2794 16.7872 16.5693 16.7407 16.8249 16.845L18.6007 17.5576L20.1131 14.9389L18.6012 13.7523C18.3853 13.5828 18.2785 13.3095 18.3231 13.0387C18.3853 12.6601 18.4156 12.3208 18.4156 12.0005C18.4156 11.6802 18.3853 11.3408 18.3231 10.9622C18.2785 10.6914 18.3853 10.4181 18.6012 10.2486L20.1131 9.062L18.6007 6.44336L16.8249 7.15593C16.5708 7.25927 16.2803 7.2147 16.0673 7.03937C15.5364 6.60351 14.9282 6.25481 14.2602 6.00259C14.0035 5.90563 13.8199 5.67691 13.7807 5.40511L13.5094 3.50492H10.4857L10.2139 5.40659C10.1747 5.6784 9.99157 5.9071 9.73495 6.00407C9.06743 6.25628 8.46113 6.60449 7.93172 7.03938C7.71869 7.21324 7.42827 7.2583 7.1741 7.15594L5.39829 6.44337L3.88647 9.06201L5.39781 10.2487C5.61379 10.4176 5.72006 10.6909 5.67598 10.9612C5.61379 11.3432 5.58342 11.6831 5.58342 12.0005C5.58342 12.3178 5.61378 12.6577 5.67598 13.0397C5.72006 13.31 5.61379 13.5833 5.39781 13.7523L3.88647 14.9389L5.39829 17.5575L7.1741 16.845C7.42974 16.7421 7.71967 16.7867 7.93172 16.9615C8.4626 17.3974 9.07086 17.7461 9.73887 17.9983C9.99549 18.0953 10.1791 18.324 10.2183 18.5958L10.4896 20.496Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9995 15.8807C9.86034 15.8807 8.1198 14.1401 8.1198 12.0005C8.1198 9.86079 9.86034 8.12026 11.9995 8.12026C14.1392 8.12026 15.8797 9.86079 15.8797 12.0005C15.8797 14.1401 14.1392 15.8807 11.9995 15.8807ZM11.9995 9.62474C10.69 9.62474 9.62429 10.6904 9.62429 12.0005C9.62429 13.3105 10.69 14.3762 11.9995 14.3762C13.3096 14.3762 14.3753 13.3105 14.3753 12.0005C14.3753 10.6904 13.3096 9.62474 11.9995 9.62474Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SettingIcon;
